import React from 'react';
import { useEmployees } from '@/contexts/EmployeeContext';

interface EmployeeSelectProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  showUnassigned?: boolean;
}

const EmployeeSelect: React.FC<EmployeeSelectProps> = ({
  value,
  onChange,
  placeholder = 'Select owner',
  required = false,
  className = '',
  disabled = false,
  showUnassigned = false,
}) => {
  const { employees, isLoading, error } = useEmployees();

  const baseClassName = `w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-emerald-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed ${className}`;

  if (isLoading) {
    return (
      <select disabled className={baseClassName}>
        <option>Loading...</option>
      </select>
    );
  }

  if (error) {
    return (
      <select disabled className={baseClassName}>
        <option>Error loading employees</option>
      </select>
    );
  }

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      disabled={disabled}
      className={baseClassName}
    >
      {showUnassigned && <option value="">{placeholder}</option>}
      {!showUnassigned && !value && <option value="">{placeholder}</option>}
      {employees.map((employee) => (
        <option key={employee.username} value={employee.name}>
          {employee.name}
        </option>
      ))}
    </select>
  );
};

export default EmployeeSelect;
